module.exports = __webpack_public_path__ + "static/media/pkw-training.b2e051db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/teaser/pkw-training.svg
// module id = 909
// module chunks = 0